module.exports = __webpack_public_path__ + "static/img/file.567c9c9a.svg";